export default "__VITE_ASSET__CTGa$sig__"